import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Card, PageTitle } from "@/components/Layout";
import { KycForm } from "@/components/KycForm";

export default function Kyc() {
  const { t, meta, user, refreshSummary } = useApp();
  const [kyc, setKyc] = useState(null);
  const load = useCallback(() => api.get("/kyc").then((r) => setKyc(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const biz = user.customer_type && user.customer_type !== "Household";
  return (
    <div className="space-y-4">
      <Link to="/profile" className="flex items-center gap-1 text-sm font-semibold text-[#2E9E6B]" data-testid="kyc-back-link"><ArrowLeft className="h-4 w-4" />{t("Profile")}</Link>
      <PageTitle>{t("KYC verification")}</PageTitle>
      <p className="text-sm text-[#4A6358]">
        {biz ? t("Businesses need to upload one ID or business document (GST, shop licence, FSSAI, Aadhaar or PAN). Our team confirms your pickups after checking it.")
          : t("Optional for households. Verified accounts get pickups confirmed faster.")}
      </p>
      <Card>{kyc ? <KycForm kyc={kyc} docs={meta?.kyc_docs || []} uploadUrl="/kyc/upload" submitUrl="/kyc" onDone={() => { load(); refreshSummary(); }} /> : <p className="text-[#7B968B]">{t("Loading…")}</p>}</Card>
    </div>
  );
}
